/**
 * useSystem provides utility methods for general app system and environment.
*/
export function useSystem() {
  /**
   * Identify dev env
   * @returns {boolean} True if dev.
   */
  const isDev = () => {
    const appEnv = process.env.MIX_APP_ENV || 'production';

    console.log('Current APP_ENV:', appEnv);
    return appEnv === 'local' || appEnv === 'development' || appEnv === 'dev';
  };

  return {
    isDev,
  };
}
